import { CircleLoader } from '@driftt/tide-core'
import classnames from 'classnames'
import React from 'react'

import './style.css'

const UniversalLoader = ({
  loaderText = 'Loading...',
  size = 'large',
  isModal = false,
  isInline = false,
  className = '',
}) => (
  <div
    className={classnames('universal-loader-container', {
      'universal-loader-container--modal': isModal,
      'universal-loader-container--inline': isInline,
      [className]: !!className,
    })}
  >
    <CircleLoader className="universal-loader-circleloader" size={size} />
    {loaderText && <span className="universal-loader-text">{loaderText}</span>}
  </div>
)

export default UniversalLoader
